export const AI_REPORT_DAY_OPTIONS = [
  { value: 1, label: "Пн" },
  { value: 2, label: "Вт" },
  { value: 3, label: "Ср" },
  { value: 4, label: "Чт" },
  { value: 5, label: "Пт" },
  { value: 6, label: "Сб" },
  { value: 7, label: "Вс" },
];

type HotelWithAiReportDays = {
  group_id?: number | string | null;
  ai_report_days?: number[] | null;
  ai_reports_enabled?: boolean;
  ai_report_settings?: { days?: number[] | null } | null;
  aiReportDays?: number[] | null;
  report_days?: number[] | null;
};

export function normalizeAiReportDays(hotel: HotelWithAiReportDays | null | undefined) {
  if (!hotel) return [];

  const rawDays =
    hotel.ai_report_days ??
    hotel.ai_report_settings?.days ??
    hotel.aiReportDays ??
    hotel.report_days ??
    null;

  const days = Array.isArray(rawDays)
    ? rawDays.map(Number).filter((day) => Number.isInteger(day) && day >= 1 && day <= 7)
    : [];

  return Array.from(new Set(days));
}

export function formatAiReportDays(days: number[]) {
  if (!days.length) return "-";
  const labels = new Map(AI_REPORT_DAY_OPTIONS.map((option) => [option.value, option.label]));
  return days
    .slice()
    .sort((left, right) => left - right)
    .map((day) => labels.get(day) ?? String(day))
    .join(", ");
}
